import { WifiOff, Cloud, CloudOff, RefreshCw } from 'lucide-react';
import { useOnlineStatus, offlineService } from '../services/offline';
import clsx from 'clsx';

export default function OfflineIndicator() {
  const { isOnline, pendingCount } = useOnlineStatus();
  const totalPending = pendingCount.orders + pendingCount.payments;

  const handleSync = () => {
    offlineService.syncPendingItems();
  };

  if (isOnline && totalPending === 0) {
    return null; // Don't show anything when fully online and synced
  }

  return (
    <div
      className={clsx(
        'fixed top-0 left-0 right-0 z-50 px-4 py-2 flex items-center justify-between text-sm font-medium',
        isOnline
          ? 'bg-amber-500 text-white'
          : 'bg-red-600 text-white'
      )}
    >
      <div className="flex items-center gap-2">
        {isOnline ? (
          <>
            <Cloud className="w-4 h-4" />
            <span>Syncing {totalPending} pending item{totalPending !== 1 ? 's' : ''}...</span>
          </>
        ) : (
          <>
            <WifiOff className="w-4 h-4" />
            <span>Offline Mode</span>
            {totalPending > 0 && (
              <span className="bg-white/20 px-2 py-0.5 rounded-full text-xs">
                {totalPending} pending
              </span>
            )}
          </>
        )}
      </div>

      {isOnline && totalPending > 0 && (
        <button
          onClick={handleSync}
          className="flex items-center gap-1 bg-white/20 hover:bg-white/30 px-2 py-1 rounded transition-colors"
        >
          <RefreshCw className="w-4 h-4" />
          <span>Retry</span>
        </button>
      )}

      {!isOnline && (
        <div className="flex items-center gap-1 text-white/80">
          <CloudOff className="w-4 h-4" />
          <span className="text-xs">Orders will sync when online</span>
        </div>
      )}
    </div>
  );
}
